import { call, put } from 'redux-saga/effects';

import generateQuery from 'utils/generateQuery';

import {
  axiosAuthInstance,
  API_END_POINTS,
} from 'api';
import { MESSAGES } from 'appconstants';

import {
  REPORTS,
  LOADING,
  NOTIFICATION,
} from '../actionTypes';

const fetchReports = async (payload) => {
  if (payload.filterParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_REPORTS}?${payload.filterParams}`);
  }
  const query = generateQuery(payload.currentPage);
  const sorting = payload.sortParams ? payload.sortParams : '&sortBy=createdAt&direction=DESC';
  return axiosAuthInstance.get(`${API_END_POINTS.GET_REPORTS}${query}${sorting}&paymentPageMetaGid.NULL=true`);
};

const addReport = async payload => axiosAuthInstance.post(API_END_POINTS.GET_REPORTS, payload);

export function* getReports(action) {
  try {
    const { data: { entity } } = yield call(fetchReports, action.payload);
    yield put({ type: REPORTS.SUCCESS, payload: entity });
  } catch (e) {
    yield put({ type: REPORTS.FAILED, payload: e.response.data });
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  }
}

export function* addReports(action) {
  try {
    yield put({ type: LOADING.SUBMITTING });
    yield call(addReport, action.payload);
    const { data: { entity } } = yield call(fetchReports);
    yield put({ type: REPORTS.SUCCESS, payload: entity });
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: MESSAGES.REPORT.GENERATE_SUCCESS,
    });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
  }
}
